// Users
export const userLogin = '/user/login'
export const userGoogleLogin = '/user/google'
export const userAppleLogin = '/user/apple'
export const userProfile = '/user/my_profile'
export const userRoles = '/user/permissions'
export const userRefresh = 'user/refresh'
export const userUpdate = '/user/update_user'
export const userUpdatePassword = '/user/update_user/password'
export const userDelete = '/user/my_profile'
export const userForgotPassword = '/user/forgot_my_password'
export const userAvatar = '/avatar'
export const userBackground = '/avatar/background'

// Notifications
export const notificationsList = '/notificaciones'
export const notificationUpdate = '/notificaciones'

// Templates (Checklists)
export const checklistList = '/checklist'
export const checklistCreate = '/checklist'
export const checklistBase = '/checklist'
export const checklistDuplicate = '/checkl/duplicate/'
export const checklistMarkArchived = '/checkl/mark-archived'

// Questions
export const questionList = '/questions'
export const questionCreate = '/questions'
export const questionBase = '/questions'
export const questionTypes = '/question_type'
export const questionPlaceholder = '/placeholder/questions/'

// Template responses (API uses `/answers_posts` path for post-level listing)
export const responseList = '/answers_posts'
export const responseCreate = '/answers/checklist'
export const responseBase = '/answers'
export const responseGenerateDocument = '/checklist/generate_document'
export const responseCorrelativeUnified = '/answers/correlative'
export const responseGenerateDocumentByCorrelative = '/checklist/generate_document_by_correlative'
